/*
 * NOTE: We want to maintain this component level template as .ts file so we can add comments and for possibly convert it into
 * a React Component based on usage level for perfomance reasons.
 */

export default {
  name: 'dashify:HealthCounts',
  title: 'Health Counts',
  owner: 'System',
  solution: '',
  tags: ['widget', 'health', 'status', 'counts'],
  createdAt: 'Jul 18, 2023, 10:15 AM',
  updatedAt: 'Jul 18, 2023, 03:00 PM',
  globals: {
    timerange: {
      since: 'now-1h',
      until: 'now',
    },
  },
  spec: {
    props: {
      headingClassName: 'text-center text-xl',
      normalHeading: 'Normal',
      warningHeading: 'Warning',
      criticalHeading: 'Critical',
      unknownHeading: 'Unknown',
      entityType: 'aws:ec2',
      normal: 0,
      warning: 0,
      critical: 0,
      unknown: 0,
      showAsPercent: false,
      showExpanded: false,
    },
    since: '/${ globals.variables.since }',
    until: '/${ globals.variables.until }',
    TIMERANGE: "${ '&since=' & since & (until ? '&until=' & until) }",
    NEXT_PUBLIC_TENANT_OBSERVE_BASE_PATH: 'https://alameda-c0-test-02.saas.appd-test.com/ui/observe', // TODO - get it from global variable
    ENTITYPATH: "${ $replace(props.entityType, ':', '/') }",
    normalStatusFilter: '/?filter=attributes(status) IN [0]&&isActive=true',
    warningStatusFilter: '/?filter=attributes(status) IN [2]&&isActive=true',
    criticalStatusFilter: '/?filter=attributes(status) IN [3]&&isActive=true',
    unknownStatusFilter: '/?filter=attributes(status) IN [1,null]&&isActive=true',
    normalStatusListPageLink:
      "${ NEXT_PUBLIC_TENANT_OBSERVE_BASE_PATH & '/' & ENTITYPATH & normalStatusFilter & TIMERANGE }",
    warningStatusListPageLink:
      "${ NEXT_PUBLIC_TENANT_OBSERVE_BASE_PATH & '/' & ENTITYPATH & warningStatusFilter & TIMERANGE }",
    criticalStatusListPageLink:
      "${ NEXT_PUBLIC_TENANT_OBSERVE_BASE_PATH & '/' & ENTITYPATH & criticalStatusFilter & TIMERANGE }",
    unknownStatusListPageLink:
      "${ NEXT_PUBLIC_TENANT_OBSERVE_BASE_PATH & '/' & ENTITYPATH & unknownStatusFilter & TIMERANGE }",
    normalColorClass: '${ $statusToHealthClassName(0) }',
    warningColorClass: '${ $statusToHealthClassName(2) }',
    criticalColorClass: '${ $statusToHealthClassName(3) }',
    unknownColorClass: '${ $statusToHealthClassName(1) }',
    totalCount: '${ props.normal + props.warning + props.critical + props.unknown }',
    normalPercent: "${ (totalCount != 0 ? $round((props.normal / totalCount * 100), 1) : 0) & '%' }",
    warningPercent: "${ (totalCount != 0 ? $round((props.warning / totalCount * 100), 1) : 0) & '%' }",
    criticalPercent: "${ (totalCount != 0 ? $round((props.critical / totalCount * 100), 1) : 0) & '%' }",
    unknownPercent: "${ (totalCount != 0 ? $round((props.unknown / totalCount * 100), 1) : 0) & '%' }",
    normalCount: '${ $toNumberShort(props.normal) }',
    warningCount: '${ $toNumberShort(props.warning) }',
    criticalCount: '${ $toNumberShort(props.critical) }',
    unknownCount: '${ $toNumberShort(props.unknown) }',
    view: [
      [
        'div',
        { className: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1' },
        [
          [
            'div',
            { className: 'justify-items-center' },
            [
              ['div', { className: '/${ props.headingClassName }' }, '/${ props.criticalHeading }'],
              [
                'dashify:Link',
                { href: '/${ criticalStatusListPageLink }' },
                [
                  [
                    'div',
                    {
                      className: "/${ criticalColorClass & ' text-4xl text-center' }",
                    },
                    '/${ props.showAsPercent ? criticalPercent : criticalCount }',
                  ],
                ],
              ],
              [
                'div',
                {
                  className: "/${ criticalColorClass & ' text-xs text-center' }",
                },
                "/${ props.showExpanded ? '( ' & (props.showAsPercent ? criticalCount : criticalPercent) & ' )' }",
              ],
            ],
          ],
          [
            'div',
            { className: 'justify-items-center' },
            [
              ['div', { className: '/${ props.headingClassName }' }, '/${ props.warningHeading }'],
              [
                'dashify:Link',
                { href: '/${ warningStatusListPageLink }' },
                [
                  [
                    'div',
                    {
                      className: "/${ warningColorClass & ' text-4xl text-center' }",
                    },
                    '/${ props.showAsPercent ? warningPercent : warningCount }',
                  ],
                ],
              ],
              [
                'div',
                {
                  className: "/${ warningColorClass & ' text-xs text-center' }",
                },
                "/${ props.showExpanded ? '( ' & (props.showAsPercent ? warningCount : warningPercent) & ' )' }",
              ],
            ],
          ],
          [
            'div',
            { className: 'justify-items-center' },
            [
              ['div', { className: '/${ props.headingClassName }' }, '/${ props.unknownHeading }'],
              [
                'dashify:Link',
                { href: '/${ unknownStatusListPageLink }' },
                [
                  [
                    'div',
                    {
                      className: "/${ unknownColorClass & ' text-4xl text-center' }",
                    },
                    '/${ props.showAsPercent ?  unknownPercent : unknownCount }',
                  ],
                ],
              ],
              [
                'div',
                {
                  className: "/${ unknownColorClass & ' text-xs text-center' }",
                },
                "/${ props.showExpanded ? '( ' & (props.showAsPercent ? unknownCount : unknownPercent) & ' )' }",
              ],
            ],
          ],
          [
            'div',
            { className: 'justify-items-center' },
            [
              ['div', { className: '/${ props.headingClassName }' }, '/${ props.normalHeading }'],
              [
                'dashify:Link',
                { href: '/${ normalStatusListPageLink }' },
                [
                  [
                    'div',
                    {
                      className: "/${ normalColorClass & ' text-4xl text-center' }",
                    },
                    '/${ props.showAsPercent ? normalPercent : normalCount }',
                  ],
                ],
              ],
              [
                'div',
                {
                  className: "/${ normalColorClass & ' text-xs text-center' }",
                },
                "/${ props.showExpanded ? '( ' & (props.showAsPercent ? normalCount : normalPercent) & ' )' }",
              ],
            ],
          ],
        ],
      ],
    ],
  },
};
